import RESTApiEndPoints from "@/services/rest-api-end-points";
import axiosService from "@/services/axios-service";
import IWasteTypeAverage from "@/models/waste-type-average";

export default class AveragesService {
  public async GetWasteTypesAverages(shipId?: number) {
    const url = `${RESTApiEndPoints.averagesUrl()}/${shipId ?? ""}`;
    return axiosService.get<IWasteTypeAverage[]>(url);
  }
}
